export var RealisedFXGainOrLossType;
(function (RealisedFXGainOrLossType) {
    RealisedFXGainOrLossType["RealisedFXGain"] = "RealisedFXGain";
    RealisedFXGainOrLossType["RealisedFXLoss"] = "RealisedFXLoss";
})(RealisedFXGainOrLossType || (RealisedFXGainOrLossType = {}));
//# sourceMappingURL=index.js.map